import { mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "g-icon"
};
const _hoisted_2 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_ctx.isVisible)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
            (_openBlock(), _createElementBlock("svg", _mergeProps(_ctx.rawAttributes, { innerHTML: _ctx.rawInnerHtml }), null, 16, _hoisted_2))
        ]))
        : _createCommentVNode("", true);
}
